<template>
  <div class="system-wrapper">
    <header-box/>
    <div class="sys-body">
      <div class="fui_aside">
        <div class="fui_aside_hide">
          <div class="fui_menu">
            <el-menu class="border-none" unique-opened text-color="#fff" background-color="#003582"
                     :default-active="routeKey" @select="menuSelect">
              <el-submenu v-for="(group,index) in menuList" :index="index.toString()" :key="group.Id">
                <template slot="title"><i :class="group.Image"></i>{{group.Name}}
                </template>
                <el-menu-item v-for="item in group.children" :key="item.Id" :index="`/${group.Url}/${item.Url}`">
                  {{item.Name}}
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </div>
        </div>
      </div>
      <div class="sys-content">
        <router-tab></router-tab>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  const headerBox = () => import('@/model/header')
  export default {
    data () {
      return {
        routeKey: '/'
      }
    },
    computed: {
      ...mapState({
        menuList: state => state.base.menuList
      })
    },
    created () {
      this.routeKey = this.$route.path
      this.getUserInfo()
      this.getPGTypeList()
      this.getAllUser()
      this.getUploadInfo()
    },
    methods: {
      ...mapActions(['getUserInfo', 'getPGTypeList', 'getAllUser', 'getUploadInfo']),
      menuSelect (v) {
        if (v !== this.$route.path) {
          this.$router.push({path: v},
        onComplete => {},
        onAbort => {})
        }
      }
    },
    watch: {
      $route (r) {
        this.routeKey = r.path
      }
    },
    components: {
      headerBox
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
  $--aside-width: 210px;

  .system-wrapper {
    height: 100%;
  }

  .sys-body {
    height: calc(100% - 75px);
    min-height: 600px;
    min-width: 720px;
    position: relative;
    z-index: 5;
    overflow: hidden;
  }

  .fui_aside {
    width: $--aside-width;
    position: absolute;
    left: 0;
    top: 0;
    transition: all .3s;
    z-index: 1001;
    height: 100%;
    background: #003582;
    box-sizing: border-box;

    &_hide {
      overflow: hidden;
      height: 100%;
    }
  }

  .fui_menu {
    width: $--aside-width;
    padding-right: 20px;
    overflow-x: hidden;
    height: 100%;

    .el-menu {
      width: $--aside-width;
    }
  }

  .sys-content {
    box-sizing: border-box;
    height: 100%;
    position: absolute;
    left: $--aside-width;
    right: 0;
    overflow: hidden;
    z-index: 8888;
    transition: all .3s;
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/page/layout/frame.vue